import jwt_decode from 'jwt-decode';
import { AUTH_KEYS } from '@core/constants';

export class AuthHelpers {
  jwtDecode = jwt_decode;

  getCookie(name: string) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  eraseCookie(name: string) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${secure}`;
  }

  clearLegacyTokenCookies(): void {
    this.eraseCookie(AUTH_KEYS.ID_TOKEN);
    this.eraseCookie(AUTH_KEYS.ACCESS_TOKEN);
    this.eraseCookie(AUTH_KEYS.REFRESH_TOKEN);
  }

  decodeToken(token: any): any {
    return this.jwtDecode(token);
  }

  redirectTo(url: string | null, params?: URLSearchParams | string): void {
    let redirectUrl = url;

    if (params) {
      redirectUrl = `${url}?${params}`;
    }

    return window.location.replace(`${redirectUrl}`);
  }

  urlOpener(url: string, self: string = '_self'): Promise<Window> {
    const windowProxy = window.open(url, self);
    if (windowProxy) {
      return Promise.resolve(windowProxy);
    } else {
      return Promise.reject();
    }
  }
}
